/* eslint-disable */
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ActionCreators from "../../actions";
import { setLyftReportData, setTuroReportData, setOtherReportData } from "../../utils/functions";
import { getCertificateFontDownloads } from "../../utils/certificateFontDownloads";
import "./certificateDownloadButton.css";

import React from "react";
import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Image,
  Document,
  StyleSheet,
  Font,
  Svg,
  Path,
} from "@react-pdf/renderer";

import kalamFont from "../../font/Kalam-Light.ttf";
import "../../font/registerPatrickHandAndCaveatPdf";
import LatoBold from "../../font/Lato-Bold.ttf";
import Lato from "../../font/Lato-Regular.ttf";
import LatoBlack from "../../font/Lato-Black.ttf";

import {
  coloradoInspectionColumns,
  getCheckStatus,
  getTireDimension,
  formatDate,
  getFullName,
  getInspectorName,
  humanTickPaths,
  handDrawnCirclePath,
} from "./coloradoInspectionData";

Font.register({ family: "kalamFont", format: "truetype", src: kalamFont });
Font.register({ family: "LatoBold", format: "truetype", src: LatoBold });
Font.register({ family: "Lato", format: "truetype", src: Lato });
Font.register({ family: "LatoBlack", format: "truetype", src: LatoBlack });

const styles = StyleSheet.create({
  body: {
    color: "#111",
    fontFamily: "Helvetica",
    fontSize: 9,
    paddingBottom: 14,
  },
  header: {
    backgroundColor: "#202020",
    paddingVertical: 14,
    paddingHorizontal: 20,
  },
  headerTitle: {
    color: "#fff",
    fontFamily: "Times-Bold",
    fontSize: 14,
    textAlign: "center",
  },
  contentPad: {
    paddingHorizontal: 30,
    paddingTop: 16,
  },
  vehicleInspectionHeading: {
    fontFamily: "Lato",
    fontSize: 15,
    letterSpacing: 1,
    marginBottom: 14,
  },
  grid: {
    flexDirection: "row",
  },
  column: {
    flex: 1,
  },
  columnLeft: {
    marginRight: 34,
  },
  columnHeaderRow: {
    flexDirection: "row",
    alignItems: "flex-end",
    borderBottomColor: "#bdbdbd",
    borderBottomWidth: 0,
    marginBottom: 6,
  },
  columnHeaderTitle: {
    flex: 1,
    fontSize: 9,
    letterSpacing: 0.6,
    color: "#555",
  },
  boxHeadCell: {
    width: 34,
    textAlign: "center",
    fontSize: 8,
    color: "#555",
  },
  pointRow: {
    flexDirection: "row",
    alignItems: "center",
    minHeight: 16,
    marginBottom: 6,
  },
  pointLabelWrap: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
  },
  pointNumber: {
    color: "#777",
    fontSize: 9,
    width: 14,
  },
  pointLabel: {
    fontFamily: "LatoBold",
    fontSize: 9.5,
  },
  subLabel: {
    color: "#444444",
    fontSize: 9,
    marginLeft: 14,
  },
  boxCell: {
    width: 34,
    alignItems: "center",
    justifyContent: "center",
  },
  box: {
    borderColor: "#444",
    borderWidth: 1,
    height: 9,
    width: 9,
    position: "relative",
  },
  humanTick: {
    height: 15,
    left: -3,
    position: "absolute",
    top: -4,
    width: 15,
  },
  lineRow: {
    flexDirection: "row",
    alignItems: "flex-end",
    minHeight: 16,
    marginBottom: 6,
  },
  lineLabel: {
    color: "#444444",
    fontSize: 9,
    marginLeft: 14,
  },
  lineSuffix: {
    color: "#444",
    fontSize: 8.5,
    marginLeft: 10,
  },
  fillLine: {
    borderBottomColor: "#222",
    borderBottomWidth: 1,
    marginLeft: 8,
    marginBottom: 2,
    width: 70,
  },
  fillLineValue: {
    fontSize: 9,
    textAlign: "center",
    paddingBottom: 1,
  },
  tireBracket: {
    color: "#444",
    fontSize: 8.5,
    marginLeft: "auto",
    marginRight: 8,
  },
  resultBox: {
    borderColor: "#444",
    borderStyle: "dashed",
    borderWidth: 1.2,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 16,
    minHeight: 56,
    paddingHorizontal: 14,
  },
  resultLabelWrap: {
    flexDirection: "column",
  },
  resultTitle: {
    fontFamily: "LatoBold",
    fontSize: 9,
  },
  resultSub: {
    color: "#444",
    fontSize: 8,
    marginTop: 2,
  },
  resultStatusRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  resultStatus: {
    alignItems: "center",
    justifyContent: "center",
    height: 42,
    marginLeft: 18,
    position: "relative",
    width: 56,
  },
  resultStatusText: {
    fontFamily: "LatoBold",
    fontSize: 10,
    textAlign: "center",
  },
  resultCircle: {
    height: 42,
    left: 10,
    position: "absolute",
    top: 0,
    width: 56,
  },
  inspectorSection: {
    backgroundColor: "#ececec",
    marginTop: 14,
    marginHorizontal: 25,
    paddingHorizontal: 30,
    paddingTop: 12,
    paddingBottom: 8,
  },
  inspectorHeading: {
    fontFamily: "LatoBlack",
    fontSize: 8,
    letterSpacing: 0.5,
    marginTop: -3,
    marginBottom: 10,
  },
  inspectorRow: {
    flexDirection: "row",
    alignItems: "flex-end",
    marginBottom: 8,
  },
  inspectorField: {
    marginRight: 24,
  },
  fieldValue: {
    borderBottomColor: "#222",
    borderBottomWidth: 1,
    fontSize: 11,
    minHeight: 16,
    paddingBottom: 2,
    justifyContent: "flex-end",
  },
  fieldLabel: {
    fontSize: 8,
    letterSpacing: 0.4,
    marginTop: 3,
    textTransform: "uppercase",
  },
  fieldLabelHint: {
    color: "#555",
    fontFamily: "Times-Bold",
    fontSize: 6,
    marginLeft: 80,
  },
  signatureImage: {
    height: 26,
    width: 130,
  },
  footnote: {
    fontFamily: "Times-Bold",
    fontSize: 8,
    lineHeight: 1.25,
    marginTop: 11,
  },
});

const HumanTick = ({ tickIndex = 0 }) => (
  <Svg style={styles.humanTick} viewBox="0 0 24 24">
    <Path
      d={humanTickPaths[tickIndex % humanTickPaths.length]}
      stroke="#000"
      strokeWidth={2.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Svg>
);

const Box = ({ checked, tickIndex }) => (
  <View style={styles.box}>{checked ? <HumanTick tickIndex={tickIndex} /> : null}</View>
);

const PassFailCells = ({ status, tickIndex }) => (
  <>
    <View style={styles.boxCell}>
      <Box checked={status === "pass"} tickIndex={tickIndex} />
    </View>
    <View style={styles.boxCell}>
      <Box checked={status === "fail"} tickIndex={tickIndex + 2} />
    </View>
  </>
);

const ColumnHeader = () => (
  <View style={styles.columnHeaderRow}>
    <Text style={styles.columnHeaderTitle}>INSPECTION POINT</Text>
    <Text style={styles.boxHeadCell}>PASS</Text>
    <Text style={styles.boxHeadCell}>FAIL</Text>
  </View>
);

const FillLine = ({ value, handwritingStyle }) => (
  <View style={styles.fillLine}>
    <Text style={[styles.fillLineValue, handwritingStyle]}>{value || ""}</Text>
  </View>
);

const PointRows = ({ point, checks, reportData, baseTick, handwritingStyle }) => {
  // All inspection points are marked PASS.
  const status = "pass";

  return (
    <View>
      <View style={styles.pointRow}>
        <View style={styles.pointLabelWrap}>
          <Text style={styles.pointNumber}>{point.number}</Text>
          <Text style={styles.pointLabel}>{point.label}</Text>
        </View>
        <PassFailCells status={status} tickIndex={baseTick} />
      </View>

      {/* Measurement / sub-checkbox rows */}
      {(point.subRows || []).map((sub, subIdx) =>
        sub.type === "checkbox" ? (
          <View style={styles.pointRow} key={sub.label}>
            <View style={styles.pointLabelWrap}>
              <Text style={styles.subLabel}>{sub.label}</Text>
            </View>
            <PassFailCells status="pass" tickIndex={baseTick + subIdx + 1} />
          </View>
        ) : (
          <View style={styles.lineRow} key={sub.label}>
            <Text style={styles.lineLabel}>{sub.label}</Text>
            {sub.suffix ? <Text style={styles.lineSuffix}>{sub.suffix}</Text> : null}
            <View style={{ marginLeft: "auto" }}>
              <FillLine value={sub.value} handwritingStyle={handwritingStyle} />
            </View>
          </View>
        )
      )}

      {/* Tire tread depth rows */}
      {(point.tires || []).map((tire) => (
        <View style={styles.lineRow} key={tire.label}>
          <Text style={styles.lineLabel}>{tire.label}</Text>
          <Text style={styles.tireBracket}>[ 32nd's / In ]</Text>
          <FillLine
            value={getTireDimension(reportData, tire.category)}
            handwritingStyle={handwritingStyle}
          />
        </View>
      ))}
    </View>
  );
};

const ResultStatus = ({ selected, children }) => (
  <View style={styles.resultStatus}>
    {selected ? (
      <Svg style={styles.resultCircle} viewBox="0 0 112 73">
        <Path
          d={handDrawnCirclePath}
          stroke="#000"
          strokeWidth={3}
          strokeLinecap="round"
          fill="none"
        />
      </Svg>
    ) : null}
    <Text style={styles.resultStatusText}>{children}</Text>
  </View>
);

const Field = ({ label, hint, value, style, handwritingStyle, children }) => {
  const wrapStyle = Array.isArray(style)
    ? [styles.inspectorField, ...style]
    : [styles.inspectorField, style];
  return (
    <View style={wrapStyle}>
      <View style={styles.fieldValue}>
        {children ? (
          children
        ) : (
          <Text style={[{ fontSize: 11 }, handwritingStyle]}>{value || ""}</Text>
        )}
      </View>
      {hint ? (
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <Text style={styles.fieldLabel}>{label}</Text>
          <Text style={styles.fieldLabelHint}>{hint}</Text>
        </View>
      ) : (
        <Text style={styles.fieldLabel}>{label}</Text>
      )}
    </View>
  );
};

function ColoradoTncCertificateDownLoad({
  checksData = [],
  reportData = {},
  handwritingFont = "kalamFont",
  fileName = "Vehicle-certificate.pdf",
  linkLabel = "Download pdf",
}) {
  const handwritingStyle = { fontFamily: handwritingFont, lineHeight: 1 };
  const finalStatus = String(reportData?.finalStatus || "").toLowerCase();
  const [leftColumn, rightColumn] = coloradoInspectionColumns;

  return (
    <div className="App">
      <PDFDownloadLink
        document={
          <Document>
            <Page size="A4" style={styles.body} wrap={false}>
              <View style={styles.header}>
                <Text style={styles.headerTitle}>
                  Colorado Public Utilities Comission
                </Text>
                <Text style={styles.headerTitle}>
                  TNC ANNUAL INSPECTION REPORT
                </Text>
              </View>

              <View style={styles.contentPad}>
                <Text style={styles.vehicleInspectionHeading}>
                  VEHICLE INSPECTION
                </Text>

                <View style={styles.grid}>
                  <View style={[styles.column, styles.columnLeft]}>
                    <ColumnHeader />
                    {leftColumn.map((point, idx) => (
                      <PointRows
                        key={point.number}
                        point={point}
                        checks={checksData}
                        reportData={reportData} certificateData={reportData}
                        baseTick={idx * 8}
                        handwritingStyle={handwritingStyle}
                      />
                    ))}
                  </View>

                  <View style={styles.column}>
                    <ColumnHeader />
                    {rightColumn.map((point, idx) => (
                      <PointRows
                        key={point.number}
                        point={point}
                        checks={checksData}
                        reportData={reportData} certificateData={reportData}
                        baseTick={100 + idx * 8}
                        handwritingStyle={handwritingStyle}
                      />
                    ))}

                    <View style={styles.resultBox}>
                      <View style={styles.resultLabelWrap}>
                        <Text style={styles.resultTitle}>VEHICLE INSPECTION</Text>
                        <Text style={styles.resultSub}>(Please circle one)</Text>
                      </View>
                      <View style={styles.resultStatusRow}>
                        <ResultStatus selected={finalStatus === "pass"}>
                          PASS
                        </ResultStatus>
                        <ResultStatus selected={finalStatus === "fail"}>
                          FAIL
                        </ResultStatus>
                      </View>
                    </View>
                  </View>
                </View>
              </View>

              <View style={styles.inspectorSection}>
                <Text style={styles.inspectorHeading}>
                  TO BE COMPLETED BY INSPECTOR
                </Text>

                <View style={styles.inspectorRow}>
                  <Field
                    label="COMPANY"
                    value="Chex Inc."
                    style={{ flex: 40 }}
                    handwritingStyle={handwritingStyle}
                  />
                  <Field
                    label="VEHICLE MILEAGE"
                    value={reportData?.milage}
                    style={[{ flex: 60 }, { marginRight: 0 }]}
                    handwritingStyle={handwritingStyle}
                  />
                </View>

                <View style={styles.inspectorRow}>
                  <Field
                    label="LICENSE PLATE #"
                    value={reportData?.licensePlateNumber}
                    style={{ flex: 40 }}
                    handwritingStyle={handwritingStyle}
                  />
                  <Field
                    label="VIN#"
                    value={reportData?.vin}
                    style={[{ flex: 60 }, { marginRight: 0 }]}
                    handwritingStyle={handwritingStyle}
                  />
                </View>

                <View style={styles.inspectorRow}>
                  <Field
                    label="VEHICLE MAKE"
                    value={reportData?.make}
                    style={{ flex: 40 }}
                    handwritingStyle={handwritingStyle}
                  />
                  <Field
                    label="VEHICLE MODEL"
                    value={reportData?.model}
                    style={{ flex: 40 }}
                    handwritingStyle={handwritingStyle}
                  />
                  <Field
                    label="VEHICLE YEAR"
                    value={reportData?.year}
                    style={[{ flex: 20 }, { marginRight: 0 }]}
                    handwritingStyle={handwritingStyle}
                  />
                </View>

                <View style={[styles.inspectorRow, { marginBottom: 4 }]}>
                  <Field
                    label="ADDRESS"
                    hint="(Street, City, State, Zip Code)"
                    value={reportData?.stateAddress}
                    style={[{ flex: 1 }, { marginRight: 0 }]}
                    handwritingStyle={handwritingStyle}
                  />
                </View>

                <View style={styles.inspectorRow}>
                  <Field
                    label="INSPECTOR NAME"
                    value={getInspectorName(reportData)}
                    style={{ flex: 40 }}
                    handwritingStyle={handwritingStyle}
                  />
                  <Field
                    label="INSPECTOR SIGNATURE"
                    style={{ flex: 40 }}
                    handwritingStyle={handwritingStyle}
                  >
                    {reportData?.Inspectorsignature ? (
                      <Image
                        style={styles.signatureImage}
                        source={`${process.env.REACT_APP_AWS_S3_LINK}/${reportData.Inspectorsignature}?x-request=xhr`}
                      />
                    ) : (
                      <Text> </Text>
                    )}
                  </Field>
                  <Field
                    label="DATE"
                    value={formatDate(reportData?.reviewedDate)}
                    style={[{ flex: 20 }, { marginRight: 0 }]}
                    handwritingStyle={handwritingStyle}
                  />
                </View>

                <Text style={styles.footnote}>
                  ´40-10.1-605(g)(I) C.R.S - Per 4 CCR 723-6-6708(b) a copy of this
                  Inspection Report must be maintained in the personal vehicle
                  in{"\n"}physical or electronic form
                </Text>
              </View>
            </Page>
          </Document>
        }
        fileName={fileName}
      >
        {({ loading }) =>
          loading ? (
            <div className="certificate-download-button is-loading" aria-live="polite">
              <span className="certificate-download-spinner" />
              <div>Preparing PDF</div>
            </div>
          ) : (
            <div
              className="certificate-download-button"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontSize: "15px",
                  marginBottom: "20px",
                  marginTop: "20px",
                  color: "#3FA9FF",
                  fontWeight: "bold",
                  marginRight: "5px",
                  cursor: "pointer",
                }}
              >
                {linkLabel}
              </div>
              <i className="fa fa-download" />
            </div>
          )
        }
      </PDFDownloadLink>
    </div>
  );
}


const ColoradoTncCertificateDownLoadConnected = (props) => {
  const { id, companyId, reportData, checksData } = props;
  React.useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      props.getVehicleCertificate({ id, companyId }, props.setLoading, "uber");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);
  return (
    <div className="certificate-download-group">
      {!reportData ? (
        <div className="certificate-download-button is-loading" aria-live="polite">
          <span className="certificate-download-spinner" />
          <div>Loading certificate data</div>
        </div>
      ) : (
        getCertificateFontDownloads(reportData?.certificateFont).map((cfg) => (
          <ColoradoTncCertificateDownLoad
            key={cfg.handwritingFont}
            reportData={reportData} certificateData={reportData}
            checksData={checksData} checks={checksData} vehicleChecksArray={checksData} firstHalfData={checksData}
            handwritingFont={cfg.handwritingFont}
            fileName={cfg.fileName}
            linkLabel={cfg.linkLabel}
          />
        ))
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const sliceData = state && state.vehicleInstruction && state.vehicleInstruction.uberVehicleCertificate;
  return {
    reportData: sliceData,
    checksData: setOtherReportData(sliceData && sliceData.Files),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ColoradoTncCertificateDownLoadConnected);
